import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import HeaderBar from "./components/Layout/HeaderBar";
import NavBar from "./components/Layout/NavBar";
import RehabCenterLocator from "./components/RehabCenterLocator/RehabCenterLocator";
import "./App.css";
import RegisterRehabCenter from "./components/RegisterRehabCenter/RegisterRehabCenter";
import AdminLogin from "./components/Adminpanel/AdminLogin";
import UserAuthModal from "./components/UserAuth/UserAuthModal";
import AccountPage from "./components/UserAuth/AccountPage";
import RehabDashboard from "./components/RehabDashboard/RehabDashboard";
import {jwtDecode} from 'jwt-decode';

function App() {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setLoggedInUser(null);
    navigate('/');
  };

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          const response = await axios.get('/api/user/account');
          setLoggedInUser(response.data);
        } catch (error) {
          console.error("Failed to fetch user profile", error);
          handleLogout();
        }
      }
    };
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openAuthModal = () => setIsAuthModalOpen(true);
  const closeAuthModal = () => setIsAuthModalOpen(false);

  const path = location.pathname;
  const showHeaderBar = !['/rehab-dashboard', '/adminlogin'].includes(path);
  const showNavBar = !['/rehab-dashboard', '/adminlogin'].includes(path);

  return (
    <>
      {showHeaderBar && (
        <HeaderBar 
          loggedInUser={loggedInUser} 
          handleLogout={handleLogout} 
          openAuthModal={openAuthModal} 
        />
      )}
      
      {showNavBar && (
        <NavBar 
          showNavLinks={path !== '/register-rehab-center'}
          showRegisterButton={path !== '/register-rehab-center' && !(loggedInUser && path === '/account')}
          showSignInButton={path === '/register-rehab-center'}
        />
      )}

      {isAuthModalOpen && <UserAuthModal closeModal={closeAuthModal} setLoggedInUser={setLoggedInUser} />}
      
      <Routes>
        <Route path="/" element={<RehabCenterLocator loggedInUser={loggedInUser} openAuthModal={openAuthModal} />} />
        <Route path="/register-rehab-center" element={<RegisterRehabCenter />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/rehab-dashboard" element={<RehabDashboard />} />
        <Route path="/account" element={<AccountPage />} />
      </Routes>
    </>
  );
}

export default App;